import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import wrangler from "../../../../assets/info/wrangler-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import { popularVehicle } from "../../../../vars/popularVehicles";

const JeepWrangler = () => {
  useSmallNav("Jeep Wrangler");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Jeep Wrangler"} bolder />
        <InfoHero image={wrangler} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Jeep Wrangler? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Jeśli tak, to trafiłeś we właściwe miejsce."}
            />
            <p>
              Kultowy Jeep Wrangler to świetny pojazd, który wciąż zachowuje
              klasyczny wygląd Wranglera.
            </p>
            <p>
              W Pedders Suspension poczyniliśmy znaczne inwestycje w szereg
              części zawieszenia, w szczególności w JK Wrangler z 2007 roku, aby
              poprawić wygląd, komfort i prowadzenie Twojego Wranglera.
            </p>
            <p>
              Oferujemy opcje sprężyn dostosowane do różnych zastosowań, lekkich
              i ciężkich, z krótkim rozstawem osi, z długim rozstawem osi,
              silnikiem diesla lub benzynowym.
            </p>
            <p>
              Specjalnie zaprojektowane, aby nie wywoływać niesławnego
              „kołysania”, nasze zestawy zawierają również amortyzator pianowy
              układu kierowniczego Pedders.
            </p>
            <p>
              Podobnie jak nasz amortyzator układu kierowniczego, wszystkie
              nasze amortyzatory są wyposażone w technologię Pedders Foam.
              Więcej szczegółów na ten temat można znaleźć w filmie poniżej.
            </p>
            <p>
              Oprócz sprężyn i amortyzatorów oferujemy również szereg innych
              elementów związanych z zawieszeniem, takich jak drążki Panharda,
              przeguby kulowe, tuleje itp..
            </p>
            <p>
              Nie wiesz, jakich zestawów lub części potrzebujesz? Skontaktuj się
              z nami, a ktoś z naszego zespołu będzie w stanie Ci pomóc.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              title={"Jeep Wrangler Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Jeep Wrangler Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Jeep")
              .models.find((e) => e.display === "Wrangler")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default JeepWrangler;
